<template>
    <div class="tips-container display-flex" :style="`padding-top: ${paddingTop}px;padding-bottom: ${paddingBottom}px;`">
      <div>
        <img :src="`${imgURI}/static/index/commenBg.jpg`"/>
      </div>
      <div class="tips-text-bor">
        <div class="c">{{tipsC}}</div>
        <div class="e">{{tipsE}}</div>
      </div>
    </div>
</template>

<script>

import config from '@/config/index'
export default {
  name: 'tips',
  props: {
    tipsC: {
      type: String
    },
    tipsE: {
      type: String
    },
    paddingTop: {
      type: Number,
      default: 0
    },
    paddingBottom: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      imgURI: config.imgURI
    }
  }
}
</script>

<style lang="scss" scoped>
.tips-container{

  .tips-text-bor{
    position: relative;
    top: 26px;
    left: -48px;
  }

  .c{
    color: #1e1e1e;
    font-size: 24px;
  }
  .e{
    font-size: 12px;
    color: #87898A;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/tips.vue